import { type Ref, ref } from 'vue'
import { readOrganisation, removeOrganisation, writeOrganisation } from '@staff/shared'

const organisation = ref<string | null>(readOrganisation())

export function useOrganisation() {
  const setOrganisation = (name: string) => {
    writeOrganisation(name)
    organisation.value = name
  }

  const clearOrganisation = () => {
    removeOrganisation()
    organisation.value = null
  }

  const getOrganisation = (): Ref<string> => {
    if (!organisation.value) {
      throw new Error('No organisation selected')
    }
    return organisation as Ref<string>
  }

  const getLastOrganisation = (): string | null => {
    return organisation.value
  }

  return { setOrganisation, clearOrganisation, getOrganisation, getLastOrganisation }
}
